<template>
  <div>
    <form class="v-form" @submit.prevent="submit">
      <div class="d-flex">
        <v-btn large class="mt-1 mr-4" icon @click="retour">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <h1 class="mb-8">
          {{
            mode == "edit" ? "Modifier un client" : "Créer un nouveau client"
          }}
        </h1>
      </div>
      <v-row>
        <v-col cols="12" sm="6" md="4">
          <v-text-field
            label="Nom"
            v-model="form.nom"
            filled
            rounded
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-text-field
            label="Prénom"
            v-model="form.prenom"
            rounded
            filled
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-text-field
            label="Adresse e-mail"
            type="email"
            rounded
            v-model="form.email"
            filled
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
            label="Adresse"
            v-model="form.adresse1"
            rounded
            filled
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
            label="Adresse (suite)"
            v-model="form.adresse2"
            rounded
            filled
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4">
          <v-text-field
            label="Code postal"
            type="number"
            step="1"
            rounded
            v-model="form.codePostal"
            filled
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="8">
          <v-text-field
            label="Ville"
            v-model="form.ville"
            filled
            rounded
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-text-field
            label="N° de tel. fixe"
            v-model="form.telephoneFixe"
            rounded
            filled
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-text-field
            label="N° de tel. portable"
            v-model="form.telephonePortable"
            rounded
            filled
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-textarea
            label="Commentaire"
            v-model="form.commentaire"
            row="3"
            filled
            rounded
          ></v-textarea>
        </v-col>
        <v-col cols="12" sm="8">
          <v-switch
            class="mt-0 pt-0"
            v-model="form.superClient"
            label="Ce client a la réduction de 10% à chaque passage"
          ></v-switch>
        </v-col>
      </v-row>
      <div class="d-flex">
        <v-spacer></v-spacer>
        <v-btn type="submit" :loading="loading" color="primary" large
          >Valider</v-btn
        >
      </div>
    </form>
  </div>
</template>

<script lang="ts">
import { db } from "../firebase";

export default {
  data: () => ({
    loading: false,
    form: {
      nom: "",
      prenom: "",
      adresse1: "",
      adresse2: "",
      codePostal: "",
      commentaire: "",
      ville: "",
      email: "",
      telephoneFixe: "",
      telephonePortable: "",
      superClient: false
    }
  }),
  props: {
    mode: String,
    client: Object,
    provenance: String
  },
  mounted() {
    if (this.mode == "edit") {
      this.form.nom = this.client.nom || "";
      this.form.prenom = this.client.prenom || "";
      this.form.email = this.client.email || "";
      this.form.adresse1 = this.client.adresse1 || "";
      this.form.adresse2 = this.client.adresse2 || "";
      this.form.codePostal = this.client.codePostal || "";
      this.form.ville = this.client.ville || "";
      this.form.telephoneFixe = this.client.telephoneFixe || "";
      this.form.telephonePortable = this.client.telephonePortable || "";
      this.form.commentaire = this.client.commentaire || "";
      this.form.superClient = this.client.superClient || false;
    }
  },
  methods: {
    retour() {
      if (this.provenance == "dashboard" || this.mode == "create") {
        this.$router.push({ name: "dashboard" });
      } else {
        if (this.mode == "edit") {
          this.$router.push({
            name: "ficheClient",
            params: { id: this.client.id }
          });
        }
      }
    },
    async submit() {
      this.loading = true;

      if (this.mode == "create") this.form.eligible = false;

      try {
        if (this.mode == "create") {
          const client = await db.collection("clients").add(this.form);
          this.$router.push({
            name: "ficheClient",
            params: { id: client.id }
          });
        }
        if (this.mode == "edit") {
          await db
            .collection("clients")
            .doc(this.client.id)
            .update(this.form);
          this.retour();
        }
        this.loading = false;
      } catch (e) {
        this.loading = false;
        console.log(e);
      }
    }
  }
};
</script>
